import { useEffect, useRef } from 'react';

const YM_ID = Number(process.env.REACT_APP_YM_ID || 0);

export default function YandexMetrica() {
    const loadedRef = useRef(false);

    useEffect(() => {
        if (process.env.NODE_ENV !== 'production') return;
        if (!YM_ID) return;
        if (loadedRef.current) return;
        loadedRef.current = true;
        if (typeof window.ym !== 'function') {
            const w = window as any;
            w.ym = function () {
                (w.ym.a = w.ym.a || []).push(arguments);
            };
            w.ym.l = Date.now();
            if (!document.getElementById('ym-tag')) {
                const s = document.createElement('script');
                s.async = true;
                s.id = 'ym-tag';
                s.src = 'https://mc.yandex.ru/metrika/tag.js';
                const a = document.getElementsByTagName('script')[0];
                a.parentNode?.insertBefore(s, a);
            }
        }
        window.ym!(YM_ID, 'init', {
            clickmap: true,
            trackLinks: true,
            accurateTrackBounce: true,
            webvisor: true,
            triggerEvent: true,
            ecommerce: 'dataLayer',
        });
    }, []);
    return null;
}
